import React from "react"
import styled, { css } from "styled-components"
import { theme } from "../../../theme"
import { Step as StepMaterial, StepIconProps, StepLabel } from "@mui/material"

export enum StepVariant {
  active = "active",
  inactive = "inactive",
  done = "done",
  warning = "warning",
  error = "error",
}

export interface StepProps {
  label: string
  variant?: StepVariant
  key?: string
  bannerStepper?: boolean
  bannerIcon?: string
}

export const Step = (props: StepProps) => {
  const { variant = StepVariant.inactive, label, key, bannerStepper, bannerIcon, ...rest } = props

  const bannerStepLabel = (
    <BannerStepLabel
      StepIconComponent={ServiceBannerStep}
      StepIconProps={{ icon: <BannerStepperIcon src={bannerIcon} /> }}
    >
      {label}
    </BannerStepLabel>
  )
  return (
    <CustomStep
      variant={variant}
      key={key}
      $bannerStepper={bannerStepper}
      completed={variant === StepVariant.done}
      {...rest}
    >
      {bannerStepper ? bannerStepLabel : <StepLabel>{label}</StepLabel>}
    </CustomStep>
  )
}

const colorsIcon = {
  [StepVariant.active]: theme.color.primary,
  [StepVariant.inactive]: theme.color.grey2,
  [StepVariant.done]: theme.color.primary,
  [StepVariant.warning]: theme.color.warning,
  [StepVariant.error]: theme.color.error,
}

const colorsLabel = {
  [StepVariant.active]: theme.color.black6,
  [StepVariant.inactive]: theme.color.grey2,
  [StepVariant.done]: theme.color.grey2,
  [StepVariant.warning]: theme.color.warning,
  [StepVariant.error]: theme.color.error,
}

const textStyle = css`
  font-style: normal;
  font-size: ${theme.fontSize.m};
  line-height: ${theme.lineHeight.m};
`

const CustomStep = styled(StepMaterial)<{ variant: StepVariant; $bannerStepper?: boolean }>`
  ${(p) =>
    !p.$bannerStepper &&
    css`
      .MuiStepLabel-label {
        color: ${colorsLabel[p.variant]};
        ${textStyle}
      }
      .MuiStepIcon-text {
        ${textStyle};
        transform: translate(0, 0.7px);
      }
      .MuiStepIcon-root {
        color: ${colorsIcon[p.variant]};
      }
    `}

  padding: 0;
`

const ServiceBannerStep = (props: StepIconProps) => {
  return <BannerStepIcon>{props.icon}</BannerStepIcon>
}

const BannerStepLabel = styled(StepLabel)`
  align-items: flex-start;

  .MuiStepLabel-label.MuiStepLabel-alternativeLabel {
    margin-top: ${theme.spacing.m};
    padding-right: ${theme.spacing.l};
    text-align: start;
    color: inherit;
  }
`

const BannerStepIcon = styled.div`
  width: ${theme.circleSize.m};
  height: ${theme.circleSize.m};
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  border: 2px solid ${theme.color.primary100};
  background-color: ${theme.color.white};
`

const BannerStepperIcon = styled.img``
